import t from "lodash/merge";
import i from "../variants/DistechLight.js";
import o from "./BaseLight.js";
const h = t(i, {
  // #region Springboard properties
  ...o
});
export {
  h as default
};
